const HCPVerificationMessageType = Object.freeze({
    HCP_BEGIN_VERIFICATION: 0,
    HCP_VERIFICATION_ERROR: 1,
    HCP_NOT_ASSIGNED: 2,
    HCP_ASSIGNED: 3,
    HCP_ASSIGNED_TO_OTHER_ORGANISATION: 4
})

export default HCPVerificationMessageType